import { css } from 'lit';
export default css ` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/**
 * 1) Layout wrapper that houses layout section components to create a layouts like
 * sidebar layouts that are 1 row across and not a grid.
 * 2) Layout that is stacked on small screens and turns into a main column
 *    right sidebar on larger screens. Default is a 60%/40% layout
 * 2) The main column stretches the full width minus the sidebar width and gap.
 *    The sidebar column can either take in a sidebar width custom property. If that's
 *    not defined, fall back to 40%. calc is used to account for half of the gap in between items.
 */
.cat-c-layout {
  display: grid;
  gap: var(--cat-space-medium);
  grid-template-columns: minmax(0, 1fr);
}
@media all and (min-width: 60rem) {
  .cat-c-layout {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1); /* 2 */
  }
}

/**
 * Right sidebar layout break faster
 * 1) Right sidebar layout that breaks to a sidebar layout at a smaller viewport than default
 */
@media all and (min-width: 48rem) {
  .cat-c-layout--break-faster {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1); /* 2 */
  }
}

/**
 * Right sidebar layout break slower
 * 1) Right sidebar layout that breaks to a sidebar layout at a large viewport than default
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Remove the gap between items on lg screens only when items sit beside one another
 */
.cat-c-layout--gap-none {
  gap: 0;
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-none {
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--cat-space-medium);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-none.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) var(--cat-sidebar-width, 40%); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Shrink the gap to 8px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-sm {
    gap: var(--cat-space-x-small);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 0.5);
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 0.5); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--cat-space-medium);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-sm.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 0.5); /* 2 */
  }
}

/**
 * Layout gap none
 * 1) Shrink the gap to 24px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-lg {
    gap: var(--cat-space-x-large);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1.5);
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1.5); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--cat-space-medium);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-lg.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1.5); /* 2 */
  }
}

/**
 * Layout gap xl
 * 1) Widen the gap to 32px between items on lg screens only when items sit beside one another
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-xl {
    gap: var(--cat-space-2x-large);
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 2);
  }
}
@media all and (min-width: 48rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-faster {
    gap: 0;
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 2); /* 2 */
  }
}
@media all and (min-width: 60rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
    gap: var(--cat-space-medium);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--gap-xl.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr) calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 2); /* 2 */
  }
}

/**
 * Left sidebar layout
 * 1) Layout that is stacked on small screens and turns into a left sidebar with main
 * content to the right
 * 2) The main column stretches the full width minus the sidebar width and gap.
 *    The sidebar column has a minimum width value (enough to accommodate navigation
 *    and other sidebar content) but stretches to fit the content placed inside it.
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--left-sidebar {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1) minmax(0, 1fr); /* 2 */
  }
}

/**
 * Left sidebar layout break faster
 * 1) Left sidebar layout that breaks to a sidebar layout at a smaller viewport than default
 */
@media all and (min-width: 48rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-faster {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1) minmax(0, 1fr); /* 2 */
  }
}

/**
 * Left sidebar layout break slower
 * 1) Left sidebar layout that breaks to a sidebar layout at a large viewport than default
 */
@media all and (min-width: 60rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-slower {
    grid-template-columns: minmax(0, 1fr);
  }
}
@media all and (min-width: 75rem) {
  .cat-c-layout--left-sidebar.cat-c-layout--break-slower {
    grid-template-columns: calc(var(--cat-sidebar-width, 40%) - var(--size-base-unit) * 1) minmax(0, 1fr); /* 2 */
  }
}
`;
